var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.8438 44.2051V82.2422C81.8437 84.7286 80.856 87.1132 79.0979 88.8713C77.3397 90.6295 74.9552 91.6172 72.4688 91.6172H28.7188C26.2323 91.6172 23.8478 90.6295 22.0896 88.8713C20.3315 87.1132 19.3438 84.7286 19.3438 82.2422V19.7422C19.3438 17.2558 20.3315 14.8712 22.0896 13.1131C23.8478 11.3549 26.2323 10.3672 28.7188 10.3672H48.0059C49.6629 10.3674 51.252 11.0257 52.4238 12.1973L80.0137 39.7871C81.1852 40.9589 81.8435 42.548 81.8438 44.2051Z",
    stroke: "#9C4900",
    strokeWidth: 6.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5938 11.9297V35.3672C50.5937 37.0248 51.2522 38.6145 52.4243 39.7866C53.5964 40.9587 55.1861 41.6172 56.8438 41.6172H80.2812",
    stroke: "#9C4900",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigSave);
export default __webpack_public_path__ + "static/media/bigSave.6f9b113c7b97520f6b85fe8fc22e66c4.svg";
export { ForwardRef as ReactComponent };